// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".c4be0b25f4766bdf577bf1b1c1cdbb9d.js";
};